import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import InlineIncidentChip from '@/components/wysiwyg-components/nodes/incident/inline/InlineIncidentChip.vue'

export default Node.create({
  name: 'inline-incident',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      incidentId: {
        default: null,
        parseHTML: element => element.getAttribute('incident-id'),
        renderHTML: attributes => ({ 'incident-id': attributes.incidentId }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'inline-incident' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['inline-incident', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(InlineIncidentChip)
  },
})
